import { Content } from "./style";

export default function Copyright() {
  const year = new Date().getFullYear();
  return (
    <Content>
      <p>© {year} N Inteligência Empresarial. Todos os direitos reservados.</p>
    </Content>
  );
}
